import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { headerFooterDataReducer } from "./reducers/headerFooterDataReducer";
import { configReducer } from "../storage/reducers/configReducer";
import { contractDetailsReducer } from "../storage/reducers/contractDetailsReducer";
import welcomeSlice from "../storage/reducers/welcomePopReducer";

import storage from "redux-persist/lib/storage/session";
import { persistReducer, persistStore } from "redux-persist";
import thunk from "redux-thunk";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  headerFooterData: headerFooterDataReducer.reducer,
  config: configReducer.reducer,
  contracts: contractDetailsReducer.reducer,
  welcomePopUp: welcomeSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});

export const persistor = persistStore(store);
